import { render } from "./Six.vue?vue&type=template&id=a230b47e"
import script from "./Six.vue?vue&type=script&lang=js"
export * from "./Six.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__